var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"module"},[_c('b-row',{staticClass:"skeleton"},[_c('b-col',{staticClass:"content",attrs:{"md":"12"}},[_c('div'),_c('div'),_c('div',{staticClass:"smaller"}),_c('div',{staticClass:"smaller"})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }